import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import './successfulModal.css';
import orderUpdatedSuccessfully from '../../assets/images/orderUpdatedSuccessfullyModal.png';
import rejectIconImage from "../../assets/images/Reject_icon_image.png";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    borderRadius: theme.spacing(2), // To adjust the modal borderRadius
  },
}));

export default function SuccessModal({
  isOpen,
  msg,
  navigatePage,
  type = "success",
}) {
  const [open, setOpen] = React.useState(isOpen);

  const navigate = useNavigate();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    navigate(navigatePage);
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        //maxWidth="md" // Adjust the maxWidth as needed
        //maxHeight="md" // Adjust the maxHeight as needed
        PaperProps={{
          style: {
            maxWidth: "370px", // Adjust the maxWidth as needed
            width: "100%",
            maxHeight: "360px",
          },
        }}
        maxHeight="300" // Adjust the maxHeight as needed
      >
        <DialogTitle sx={{ m: 0, p: "0px 0px" }} id="customized-dialog-title">
          {/* Modal title */}
          <div className="orderUpdatedSuccessfullyModalImagediv">
            {type == "success" ? (
              <img
                className="orderUpdatedSuccessfullyModalImage"
                src={orderUpdatedSuccessfully}
              />
            ) : (
              type == "error" && (
                <img
                  className="orderUpdatedSuccessfullyModalImage"
                  src={rejectIconImage}
                />
              )
            )}
            <h4 className="headingForOrderUpdateSuccessfullyModal">{msg}</h4>
          </div>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            backgroundColor: "white",
            height: "7%",
            width: "6%",
          }}
        >
          <CloseIcon />
        </IconButton>
      </BootstrapDialog>
    </React.Fragment>
  );
}
